
import React, { Component}  from 'react';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { InputNumberWidget, InputSmartNumberWidget } from 'form/InputWidget';


const Index = styled.div`
  border: 1px solid #333333;
  border-radius: 2px;
  font-weight: bold;
  text-align: center;
  line-height: 24px;
`;

const StyledTariffPointServiceForm = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 34px 1fr 120px 100px 20px;
  margin-bottom: 20px;
  align-items: center;
  
  .label {
    font-weight: 600;
  }
  
  .description {
    font-size: 12px;
    color: #828282;
  }
  
  .tariffication_display {
    font-size: 12px;
    color: #828282;
  }
`;


export class OrderPointServiceForm extends Component {

  removePointService = () => {
    const { context, pointService, pointIndex, serviceIndex } = this.props;
    if (pointService.id) {
      context.setValue(`points.${pointIndex}.services.${serviceIndex}.cost`, 0);
      context.setValue(`points.${pointIndex}.services.${serviceIndex}.is_delete`, true);
    }
    else {
      context.removeArrayValue(`points.${pointIndex}.services`, serviceIndex);
    }
  };

  handleChange = (name, value) => {
    const { context, pointIndex, serviceIndex } = this.props;
    context.setValue(`points.${pointIndex}.services.${serviceIndex}.${name}`, value);
  };

  render() {
    const { pointService, number } = this.props;

    return (
      <StyledTariffPointServiceForm>
        <div>
          <Index>{number}</Index>
        </div>
        <div>
          <div className={'label'}>{pointService.service.label}</div>
          <div className="tariffication_display mt-2">
            {pointService.service.tariffication_display}
            {', '}
            {pointService.service.financial_schema_display}
          </div>
          {pointService.service.description && (
            <div className="description mt-2">{pointService.service.description}</div>
          )}
        </div>
        <div>
          <InputNumberWidget
            value={pointService.cost}
            label={'Цена, ₽'}
            size={'small'}
            onChange={(value) => this.handleChange('cost', value)}
            InputLabelProps={{
              shrink: true
            }}
          />
        </div>
        <div>
          <InputSmartNumberWidget
            value={pointService.quantity}
            label={'Количество'}
            size={'small'}
            onChange={(value) => this.handleChange('quantity', value)}
            InputLabelProps={{
              shrink: true
            }}
          />
        </div>
        <div>
          <IconButton tabIndex={'-1'} size={'small'} onClick={() => this.removePointService()}>
            <ClearIcon/>
          </IconButton>
        </div>
      </StyledTariffPointServiceForm>
    )
  }
}
